import { TableContainer } from '@chakra-ui/react'
import { HeadingPages } from '../../../components/HeadingPages'
import { Layout } from '../../../components/Layout'
import * as T from '../../../components/Table'
import { ListControleCompreGanhe } from './ListControleCompreGanhe'
import { api } from '../../../services/api'
import { useQuery } from 'react-query'
import { format } from 'date-fns'

async function getControleCompreGanhe() {
  const response = await api.get('/brinde-crm/listar')

  return response.data.map((product) => ({
    ...product,
    DT_CAD: product.DT_CAD ? format(new Date(product.DT_CAD), "dd/MM/yyyy 'às' HH:mm") : '',
    DT_ENTRADA: product.DT_ENTRADA ? format(new Date(product.DT_ENTRADA), "dd/MM/yyyy 'às' HH:mm") : '',
  }))
}

export function ControleCompreGanheProducao() {
  const { data, isLoading } = useQuery({
    queryKey: 'controle-compre-ganhe',
    queryFn: getControleCompreGanhe,
  })

  console.log(data)

  return (
    <>
      <HeadingPages name="Controle Compre Ganhe" />

      <Layout>
        <TableContainer w="100%">
          <T.Table>
            <T.Thead>
              <T.Tr>
                <T.Th>Nome</T.Th>
                <T.Th>Data entrada</T.Th>
                <T.Th>Data cadastro</T.Th>
                <T.Th>Quantidade Estoque</T.Th>
                <T.Th>Quantidade minima de Estoque</T.Th>
                <T.Th>Reestocar</T.Th>
              </T.Tr>
            </T.Thead>
            <T.Tbody>
              <ListControleCompreGanhe list={data} />
            </T.Tbody>
          </T.Table>
        </TableContainer>
      </Layout>
    </>
  )
}
